var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"primary",staticStyle:{"height":"100px","width":"100vw"},attrs:{"dark":"","padless":"","elevation":"4","rounded":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }